module.exports = function(product, options) {
  if(product.properties._availabilityCanPreOrder === 'true') {
    return options.fn(this);
  }
  return options.inverse(this);
};